import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { IconOutcomesLine } from '@instructure/ui-icons';
import { withStyle, jsx } from '@instructure/emotion';
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
var OutcomeLabels = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(OutcomeLabels, _React$Component);
  var _super = _createSuper(OutcomeLabels);
  function OutcomeLabels() {
    var _this;
    _classCallCheck(this, OutcomeLabels);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.wrap = function (str, includeComma) {
      return jsx("span", {
        key: str
      }, jsx("span", {
        css: _this.props.styles.pill
      }, str), includeComma && jsx("span", {
        css: _this.props.styles.pill
      }, ",\xA0"));
    };
    return _this;
  }
  _createClass(OutcomeLabels, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        outcomes = _this$props.outcomes,
        emptyText = _this$props.emptyText;
      var filteredOutcomes = outcomes.filter(function (outcome) {
        return outcome.decorator !== 'HIDE';
      });
      return jsx("div", {
        css: this.props.styles.line,
        "data-automation": "outcomeLabel__alignedOutcomes",
        "data-testid": "prueba"
      }, jsx(Text, {
        size: "medium"
      }, jsx(IconOutcomesLine, null)), jsx(Text, {
        size: "small"
      }, jsx("div", {
        css: this.props.styles.text
      }, filteredOutcomes.length === 0 ? emptyText : filteredOutcomes.map(function (o, i) {
        return _this2.wrap(o.title, i < filteredOutcomes.length - 1);
      }))));
    }
  }]);
  OutcomeLabels.displayName = "OutcomeLabels";
  return OutcomeLabels;
}(React.Component), _class2.propTypes = {
  outcomes: PropTypes.array.isRequired,
  emptyText: PropTypes.string.isRequired,
  styles: stylesShape
}, _class2)) || _class);
export { OutcomeLabels as default };